import type { IUser } from '@/types/user';

import { apiClient, API_URL } from '@/utils/apiClient';

export const buildGoogleAuthUrl = (returnUrl?: string): string => {
  const callbackBase = `${window.location.origin}/auth/callback`;
  const callbackUrl = returnUrl
    ? `${callbackBase}?returnUrl=${encodeURIComponent(returnUrl)}`
    : callbackBase;
  return `${API_URL}/auth/google?returnUrl=${encodeURIComponent(callbackUrl)}`;
};

export const initiateGoogleAuth = (returnUrl?: string): void => {
  window.location.assign(buildGoogleAuthUrl(returnUrl));
};

export const signInWithEmail = async (email: string, password: string): Promise<string> => {
  const { data } = await apiClient.post('/auth/email/signin', { email, password });
  return data.token;
};

export const getCurrentUser = async (): Promise<IUser> => {
  const { data } = await apiClient.get('/me');

  return data.user;
};
